<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<router-link to="/verify" class="back-btn"><span></span>企业认证</router-link>
		</div>
		<div class="ld-panel-main">
			<el-steps :active="0" finish-status="success" simple style="margin-bottom: 30px;">
			    <el-step title="上传证件照片" />
			    <el-step title="确认并完善信息" />
				<el-step title="客服转账验证" />
				<el-step title="实名认证完成" />
			</el-steps>
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="认证方式">
					企业认证<router-link to="/verify/reselect" class="auth-back">【重新选择认证方式】</router-link>
				</el-form-item>
				<el-form-item label="营业执照" prop="businessLicenceImg">
					<el-upload
						ref="picUploadRef"
						class="avatar-uploader"
						action="#"
						list-type="picture-card"
						:file-list="businessLicenceFile"
						:limit="1"
						:http-request="uploadPic"
						:before-upload="beforePicUpload"
						:on-preview="picPreview"
					>
						<el-button type="primary" plain>上传文件</el-button>
						<template #tip>
							<div class="el-upload__tip">温馨提示：上传附件类型支持gif、jpg、jpeg、bmp、png，大小必须在55K~1M之间！</div>
						</template>
					</el-upload>
				</el-form-item>
				<el-form-item label="企业名称" prop="companyName">
					<el-input v-model="groupForm.companyName" autocomplete="off" />
				</el-form-item>
				<el-form-item label="统一社会信用代码" prop="businessLicence">
					<el-input v-model="groupForm.businessLicence" autocomplete="off" />
				</el-form-item>
				<el-form-item label="企业法人姓名" prop="companyTrueName">
					<el-input v-model="groupForm.companyTrueName" autocomplete="off" />
				</el-form-item>
				<el-form-item label="法人身份证(头像面)" prop="IDCardImgFront">
					<el-upload
						ref="cardUploadRef"
						class="avatar-uploader"
						action="#"
						list-type="picture-card"
						:file-list="IDCardImgFrontFile"
						:limit="1"
						:http-request="uploadCard"
						:before-upload="beforePicUpload"
						:on-preview="picPreview"
					>
						<el-button type="primary" plain>上传文件</el-button>
						<template #tip>
							<div class="el-upload__tip">温馨提示：上传附件类型支持gif、jpg、jpeg、bmp、png，大小必须在55K~1M之间！</div>
						</template>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm(ruleFormRef)">下一步</el-button>
				</el-form-item>
			</el-form>
			<div class="foot-warn" style="margin-top: 60px;">
				<h4 class="title">温馨提示：</h4>
				<div class="content">
					<p>1. 请确保企业名称、统一社会信用代码、企业法人姓名等信息完全正确，否则会认证失败</p>
					<p>2. 企业认证将以对公账户打款的方式进行，请您确保对公账户信息正确，否则会打款失败</p>
					<p>3. 认证审核通过后，请您提交正确的打款金额，输入打款金额连续错误3次后，自动审核失败，您需要重新提交资料进行审核</p>
					<p>4. 注册手机号必须属本人所有，请勿使用他人手机进行注册，否则认证会失败，如果非本人手机号码，请先修改手机号再进行实名认证,不支持手机号为 170开头的实名认证</p>
					<p>5. 请勿使用虚假信息认证，否则蓝队云有权注销您的实名认证申请</p>
					<p>6. 蓝队云会加密保存您的认证资料，绝不会泄露用户隐私，请放心认证</p>
					<p>7. 所填写资料仅用于实名认证，不会开通其他任何附加服务，蓝队云工作人员不会向您索要短信验证码，谨防上当</p>
				</div>
			</div>
		</div>
	</div>
	
	<el-dialog title="图片预览" v-model="dialogVisible">
	    <img w-full :src="dialogImageUrl" alt="Preview Image" style="display: block; max-width: 100%; max-height: 70vh; margin: 0 auto;" />
	</el-dialog>
	  
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { lduploadfile } from '@/api/common';
	import { authInfo,companyverify,getocrinfo } from '@/api/auth';
	import { Delete, Plus, ZoomIn } from '@element-plus/icons-vue';
	import sideNav from '../../components/sideNav.vue';
	import { ElMessage } from 'element-plus';
	
	const router = useRouter();
	const pageTitle = 'account';
	const showFlag = ref(false);
	const userId = ref('');
	const imgId = ref('');
	const dialogImageUrl = ref('')
	const dialogVisible = ref(false)
	const picUploadRef = ref(null);
	const cardUploadRef = ref(null);
	const businessLicenceFile = ref([]);
	const IDCardImgFrontFile = ref([]);
	const formLabelWidth = ref('200px');
	const ruleFormRef = ref(null);
	const groupForm = ref({companyName:'',businessLicence:'',companyTrueName:'',businessLicenceImg:'',IDCardImgFront:''});
	const rules = reactive({
		companyName: [
			{ required: true, message: '请填写企业名称', trigger: 'blur' }
		],
		businessLicence: [
			{ required: true, message: '请填写统一社会信用代码', trigger: 'blur' }
		],
		companyTrueName: [
			{ required: true, message: '请填写企业法人姓名', trigger: 'blur' }
		],
		businessLicenceImg: [
			{ required: true, message: '请上传营业执照', trigger: 'blur' }
		],
		IDCardImgFront: [
			{ required: true, message: '请上传法人身份证', trigger: 'blur' }
		]
	});
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == '1' && res.data.authType == '2') {
					router.push({ path: '/verify/success' })
				}
				if (res.data.businessStatus == '2') {
					router.push({ path: '/verify/audit' })
				}else if(res.data.businessStatus == '4'){
					router.push({ path: '/verify/check' })
				}else{
					groupForm.value = res.data;
					if (res.data.IDCardImgFront !== '') {
						const IDCardImgFrontArray = [{
							url: res.data.IDCardImgFrontUrl,
						}];
						IDCardImgFrontFile.value = IDCardImgFrontArray;
					}
					if (res.data.businessLicenceImg !== '') {
						const businessLicenceArray = [{
							url: res.data.businessLicenceImgUrl,
						}];
						businessLicenceFile.value = businessLicenceArray;
					}
					userId.value = res.data.userId;
					showFlag.value = true;
				}
			}
		})
	};
	const beforePicUpload = (file) => {
		const fileName = file.name;
		const fileType = fileName.substring(fileName.lastIndexOf('.'));
		const isOKType =
			fileType === '.jpg' ||
			fileType === '.png' ||
			fileType === '.jpeg' ||
			fileType === '.bmp' ||
			fileType === '.gif';
			if (!isOKType) {
				ElMessage({
					offset: 70,
					message: '图片格式只能为jpeg/png/jpg/bmp/gif',
					type: 'error'
				})
			}
		const fileSizeInKB  = file.size / 1024
		const isLt2M = fileSizeInKB >= 55 && fileSizeInKB <= 1024;
		if (!isLt2M) {
			ElMessage({
				offset: 70,
				message: '图片必须在55K~1M之间!',
				type: 'error'
			})
		}
		return isLt2M && isOKType;
	};
	const uploadPic = (file) => {
		let formData = new FormData();
		const blob = file.file;
		formData.append("type", 1);
		formData.append("file", blob);
		formData.append("cate", 'auth');
		formData.append("userid", userId.value);
		lduploadfile(formData).then((res) => {
			if (res.code == 200) {
				groupForm.value.businessLicenceImg = res.info.file;
				getocrinfoF(parseInt(res.info.file))
			} else{ 
				const elementUpload = picUploadRef.value;
				elementUpload.abort();
				elementUpload.clearFiles()
				ElMessage({
					offset: 70,
					message: res.message,
					type: 'error'
				})
			}
		})
	};
	const uploadCard = (file) => {
		let formData = new FormData();
		const blob = file.file;
		formData.append("type", 1);
		formData.append("file", blob);
		formData.append("cate", 'auth');
		formData.append("userid", userId.value);
		lduploadfile(formData).then((res) => {
			if (res.code == 200) {
				groupForm.value.IDCardImgFront = res.info.file
			} else{ 
				const elementUpload = cardUploadRef.value;
				elementUpload.abort();
				elementUpload.clearFiles()
				ElMessage({
					offset: 70,
					message: res.message,
					type: 'error'
				})
			}
		})
	};
	const getocrinfoF = (val) => {
		const param = {'imgid':val,'type':'yyzz'};
		getocrinfo(param).then((res) => {
			if(res.code === 200){
				groupForm.value.companyName = res.data.companyName;
				groupForm.value.businessLicence = res.data.companyCode;
				groupForm.value.companyTrueName = res.data.trueName;
			}
		})
	};
	const picPreview = (uploadFile) => {
		dialogImageUrl.value = uploadFile.url
		dialogVisible.value = true
	};
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			const param = groupForm.value;
			companyverify(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					router.push({ path: '/verify/businessinfo' })
				}
			})
	    } else {
	      return false;
	    }
	  });
	};
	
	onMounted(() => {
		generData()
	})
	
</script>

<style lang="scss" scoped>
	
</style>